import { apiRequest } from './httpClient';

// Pay Per Meeting: one meeting, bought with a one-time payment. Not a
// plan and not a subscription - see backend/routers/meeting_passes.py.
// Same apiRequest as every other service.

// What the product costs and grants: { name, price, currency, meetings,
// duration_limit_minutes, available }. Public - the pricing page shows
// the card to signed-out visitors. The card is rendered from THIS, so no
// price or duration is hardcoded in the frontend.
export function getProduct() {
  return apiRequest('/api/meeting-passes/product');
}

// Opens a one-time order for one pass.
//
// Sends NO body, deliberately: the price, the currency, how many
// meetings and how long they may run are all the server's. There is
// nothing here a tampered client could set.
//
// Returns { provider_order_id, key_id, name, description, amount,
// currency, meetings, duration_limit_minutes }. `amount` is for display.
export function startCheckout() {
  return apiRequest('/api/meeting-passes/checkout', { method: 'POST' });
}

// Reports the browser checkout handler's result.
//
// GRANTS NOTHING by itself. The backend checks the signature and then
// asks the provider whether the order was paid; the answer's `status` is
// 'processing' until that is confirmed, then 'available'.
//
// Note the id is an ORDER id - a subscription checkout hands back a
// subscription id instead (billingApi.verifyCheckout), and the two are
// not interchangeable.
export function acknowledgeCheckout(handlerResponse) {
  return apiRequest('/api/meeting-passes/checkout/acknowledge', {
    method: 'POST',
    body: {
      razorpay_order_id: handlerResponse.razorpay_order_id,
      razorpay_payment_id: handlerResponse.razorpay_payment_id,
      razorpay_signature: handlerResponse.razorpay_signature,
    },
  });
}

// The signed-in user's own purchased meetings: { available_passes,
// pending_purchases, consumed_passes, product }. Read-only.
export function getMyPasses() {
  return apiRequest('/api/meeting-passes/me');
}

// Re-checks the user's own unconfirmed purchases with the provider, then
// answers like getMyPasses(). For a payment whose confirmation has not
// come through yet.
export function refreshPurchases() {
  return apiRequest('/api/meeting-passes/refresh', { method: 'POST' });
}
